<template>
  <div>
    <transition name="fade">
      <location-add-edit
        v-if="showNewLocation"
        :team-id="team.teamId"
        :edit="false"
        :already-used-colors="locations.map(loc => loc.color)"
        :already-used-workplace-names="locations.map(loc => loc.name)"
        @close="showNewLocation = false"
        @save="load"
      />
    </transition>
    <section>
      <div class="over-table">
        <search-bar
          class="search-user"
          @input="input => (search = input)"
        />
        <div class="add-workplace">
          <button
            class="clavo-button secondary"
            @click="showNewLocation = true"
          >
            {{ $t('addWorkplace') }}
          </button>
        </div>
      </div>

      <locations
        v-if="locationsLoaded"
        :searched-name="search"
        :locations="locations"
        :location-color-names="locationColorNames"
        :team="team"
        @delete-location="removeLocationFromList"
        @reload-locations="load"
      />
    </section>
  </div>
</template>

<script>
import SearchBar from '@/components/UI/SearchBar'
import User from '@/components/User'
import Locations from '@/components/Location/WorkplacesList'
import LocationAddEdit from '@/components/Location/AddEdit'
import ParseFunctions from '@/components/ParseFunctions'
import Constants from '@/components/Constants'

export default {
  components: {
    Locations,
    LocationAddEdit,
    SearchBar,
  },
  mixins: [User, ParseFunctions, Constants],
  props: {
    team: Object,
  },
  data() {
    return {
      newWorkplaceName: '',
      showNewLocation: false,
      search: '',
      locations: null,
      locationColorNames: {},
      placeholder: 'Search',
      locationsLoaded: false,
    }
  },
  async created() {
    await this.load()
  },
  methods: {
    async load() {
      this.getTeamById(this.team.teamId)  // it updates the team in vuex store, in particular the locationsUpdatedAt property
      let res = await this.getLocations(this.team.teamId)

      if (res.status === 'ok'){
        this.locations = res.locations

        for (let i = 0; i < this.locations.length; i++) {
          if (!(this.locations[i].color in this.locationColorNames))
            this.$set(this.locationColorNames, this.locations[i].color, await this.hex2name(this.locations[i].color))
        }
        this.locationsLoaded = true
        this.allDataRefreshed = true
      }else{
        this.allDataRefreshed = false
        this.showServerError(res)
      }

    },
    removeLocationFromList(locationId) {
      this.locations = this.locations.filter(l => l.id !== locationId)
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  // margin: 18px 0 19px 0;

  .over-table {
    display: flex;
    position: sticky;
    flex-direction: row;
    justify-content: space-between;
    padding: 18px;
    background: white;
    top: 0;
    z-index: 1;

    .search-user {
      width: 60%;
    }
  }

  @include respond-below(sm) {
    .over-table {
      .search-user {
        flex: 1 1 auto;
        margin-right: 18px;
      }
    }
  }
  @include respond-below(xs) {
    .over-table {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      .search-user {
        width: 100%;
        align-self: stretch;
      }
      button {
        margin-top: 12px;
        width: 100%;
      }
    }
  }
}
</style>
